// extracted by mini-css-extract-plugin
export default {"root":"dONSs4","blockingLayer":"cAi1rj","dialog":"XY7wQv","frameWrap":"wjVIs_","iframe":"TOw_tv","xButton":"Mv_ZYX","root-editor":"TotfZu","rootEditor":"TotfZu","bare":"gYoaeq"};